<ng-container [ngSwitch]="type">
  <ng-container *ngSwitchCase="'primary'">
    <ng-container *ngTemplateOutlet="button; context: { $implicit: 'primary' }">
    </ng-container>
  </ng-container>
  <ng-container *ngSwitchCase="'secondary'">
    <ng-container
      *ngTemplateOutlet="button; context: { $implicit: 'secondary' }"
    >
    </ng-container>
  </ng-container>
  <ng-container *ngSwitchDefault>
    <ng-container *ngTemplateOutlet="button; context: { $implicit: '' }">
    </ng-container>
  </ng-container>
</ng-container>
<ng-template #button let-buttonType>
  <button
    (click)="action.emit($event)"
    [ngClass]="[customClass, mode, buttonType, selected ? 'selected' : '']"
    class="button"
    [disabled]="isDisabled"
    [type]="type"
  >
    <ng-content select="[prefixContent]"></ng-content>
    <span>
      {{ label }}
    </span>
    <ng-content select="[postfixContent]"></ng-content>
  </button>
</ng-template>
